import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  BaseComponent,
} from '@wms/app/components';
import { DialogService } from '@wms/app/services';

@Component({
  selector: 'wms-upgrade-prefab',
  templateUrl: './upgrade-prefab.component.html',
  styleUrls: ['./upgrade-prefab.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
  ],
})
export class UpgradePrefabComponent extends BaseComponent {
  @Input() prefabUpdate: any;
  conflictMessage: string;
  dialogParams:any
  constructor(
    private dialogService: DialogService,
  ) {
    super();
  }

  ngOnInit() {
    let dialogObject: any = this.dialogService.dialogs.find(dialog => dialog.id === 'upgradePrefabDialog');
    this.dialogParams = dialogObject.dialogParams
  }

  closeDialog() {
    this.dialogService.close('upgradePrefabDialog');
  }

}
